import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoveJobMatchStepComponent } from './move-job-match-step.component';
import { FormsModule } from '@angular/forms';
import { ExternalNotesModule } from '../../external-notes/external-notes.module';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [MoveJobMatchStepComponent],
  imports: [
    CommonModule,
    FormsModule,
    ExternalNotesModule,
    AiAssistantModule
  ],
  exports: [MoveJobMatchStepComponent],
  entryComponents: [MoveJobMatchStepComponent]
})
export class MoveJobMatchStepModule { }
